import React from "react";

import { Field, FieldProps } from "formik";

import { TextInput, TextInputProps } from "..";

export interface TextInputFormikProps extends TextInputProps {
  className?: string;
  name: string;
  postSingleAnswer?: (value: string | string[], uuid: string) => {};
  required?: boolean;
}

export const TextInputFormik: React.FC<TextInputFormikProps> = ({
  className,
  name,
  postSingleAnswer = () => {},
  required = false,
  ...props
}) => {
  return (
    <div className={className}>
      <Field name={name}>
        {({ field }: FieldProps) => {
          return (
            <TextInput
              variant="underline"
              {...props}
              {...field}
              required={required}
              onChange={(event) => {
                if (postSingleAnswer) {
                  postSingleAnswer([event.target.value], name);
                }
                field.onChange(event);
              }}
            />
          );
        }}
      </Field>
      {/* <Field {...props} name={name} as={TextInput}  /> */}
    </div>
  );
};
